import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import moment from 'moment';
import { combineLatest, ReplaySubject } from 'rxjs';
import { filter, takeWhile } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { Calendar, SelectItem } from '../../shared/efaact-primeng.module';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-reconciliation-filters',
    templateUrl: './reconciliation-filters.component.html',
    styleUrls: ['./reconciliation-filters.component.scss'],
    standalone: false
})
export class ReconciliationFiltersComponent implements OnInit, OnDestroy {
    @Input() templates: SelectItem[];
    private PayPeriodDatesSubject = new ReplaySubject<SelectItem[]>(1);
    private _payPeriodDates: SelectItem[];
    @Input() public set payPeriodDates(value: SelectItem[]) {
        this._payPeriodDates = value;
        this.PayPeriodDatesSubject.next(value);
    }
    public get payPeriodDates(): SelectItem[] {
        return this._payPeriodDates;
    }
    @Input() public set userInfo(value: IUserInfo) {
        this.UserInfoSubject.next(value);
        if (value) {
            this.formGroup.controls['ReconDates'].setValue([
                value.PrevPayPeriodStart,
                value.PrevPayPeriodEnd
            ]);
        }
    }
    @Input() showFilterDates = false;
    @Input() showPayPeriods = false;
    @Input() showTemplates = false;
    @Output() public DateRangeSelected = new ReplaySubject<any>(1);
    @Output() public TemplateSelected = new ReplaySubject(1);
    @Output() public Memorize = new ReplaySubject(1);
    @ViewChild('filterDates', { static: true }) filterDates: Calendar;
    formGroup: UntypedFormGroup;
    private active = true;
    private UserInfoSubject = new ReplaySubject<IUserInfo>(1);
    constructor(private log: LoggingService) {
        this.formGroup = new UntypedFormGroup({
            ReconDates: new UntypedFormControl(),
            ReconTemplate: new UntypedFormControl(),
            PayPeriod: new UntypedFormControl()
        });
    }

    ngOnInit(): void {
        this.setupSubscriptions();
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    setupSubscriptions() {
        const form = this.formGroup.controls;
        form['ReconDates'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(dates => {
                this.log.verbose({
                    type: 'ReconciliationFiltersComponent:ReconDates',
                    dates
                });
                if (moment(dates[0]).isValid() && moment(dates[1]).isValid()) {
                    this.DateRangeSelected.next(dates);
                    this.filterDates.hideOverlay();
                }
            });
        form['PayPeriod'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(dates => {
                this.log.verbose({
                    type: 'ReconciliationFiltersComponent:PayPeriod',
                    dates
                });
                this.DateRangeSelected.next(dates);
            });
        form['ReconTemplate'].valueChanges
            .pipe(takeWhile(() => this.active))
            .subscribe(template => {
                this.log.verbose({
                    type: 'ReconciliationFiltersComponent:ReconTemplate',
                    template
                });
                this.TemplateSelected.next(template);
            });
        combineLatest([this.UserInfoSubject, this.PayPeriodDatesSubject])
            .pipe(
                takeWhile(() => this.active),
                filter(([userinfo, payperiods]) => !!userinfo && !!payperiods)
            )
            .subscribe(([userinfo, payperiods]) => {
                const payPeriod = payperiods.find(x =>
                    x.label.startsWith(
                        moment(userinfo.PrevPayPeriodStart).format('MM/DD/YY')
                    )
                );
                this.log.verbose({
                    type: 'ReconciliationFiltersComponent:UserInfoSubject',
                    payperiods,
                    userinfo,
                    payPeriod
                });
                if (payPeriod) {
                    this.formGroup.controls['PayPeriod'].setValue(
                        payPeriod.value
                    );
                }
            });
    }
}
